export default [
    {
		path: "/timeline/search",
		component: () => import("../views/Timeline/Search.vue"),
		meta: {
			hasmainmenu: true
		}
	},
    {
		path: "/timeline/batchdownload/:jobid?",
		component: () => import("../views/Timeline/BatchDownload.vue"),
		meta: {
			hasmainmenu: false
		}
	},
]
